import React from "react"
import { Box, Grid, Heading, Container, Text, Flex } from "@theme-ui/components"
import { InboundLink } from "./link"
import { getPagePath } from "../utils/path"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"

const BigTitle = ({ block }) => {
  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  console.log(block.contact)
  return (
    <Container sx={{ py: [5, 5, 6, 8], px: [3, 3, 4, 5] }}>
      <Flex
        sx={{
          flexDirection: "column",
          justifyContent:
            block.contact === true
              ? "center"
              : ["flex-start", "flex-start", "center", "center"],
          alignContent:
            block.contact === true
              ? "center"
              : ["flex-start", "flex-start", "center", "center"],

          alignItems:
            block.contact === true
              ? "center"
              : ["flex-start", "flex-start", "center", "center"],
        }}
      >
        {block.kicker && (
          <Box
            sx={{
              textAlign:
                block.contact === true
                  ? "center"
                  : ["start", "start", "center", "center"],
            }}
          >
            <Text variant="kicker">{block.kicker}</Text>
          </Box>
        )}
        <Box
          sx={{
            width: ["80%", "100%", "80%"],
            textAlign:
              block.contact === true
                ? "center"
                : ["start", "start", "center", "center"],
            h2: {
              textAlign:
                block.contact === true
                  ? "center"
                  : ["start", "start", "center", "center"],
              fontSize: [6, 7, "110px", "120px"],

              lineHeight: "heading",
              textTransform: "uppercase",
              fontWeight: 700,
              color: "dark",
              lineHeight: 0.9,
              my: 5,
              em: {
                display: "block",
                color: "primary",
                fontStyle: "normal",
              },
            },
            h4: {
              color: "dark",
              fontWeight: 700,
              textAlign: "center",
              fontSize: [4, 4, 5, "48px"],
              textTransform: "uppercase",
              lineHeight: 0.9,
              mt: "30px",
              a: {
                fontSize: [4, 4, 5, "48px"],
                color: "primary",
                ":hover": {
                  color: "secondary",
                },
              },
            },
            h3: {
              wordBreak: "break-word",
              lineHeight: 0.9,
              textTransform: "uppercase",
              color: "dark",
              textAlign:
                block.contact === true
                  ? "center"
                  : ["start", "start", "center", "center"],
              my: [5, 5, 3, 4],
              fontSize: [6, 6, 7, "90px"],
              "& > em:nth-of-type(1)": {
                display: "inline",
                color: "primary",
                fontStyle: "normal",
                textAlign:
                  block.contact === true
                    ? "center"
                    : ["start", "start", "center", "center"],
              },
              "& > em:nth-of-type(2)": {
                textAlign:
                  block.contact === true
                    ? "center"
                    : ["start", "start", "center", "center"],
                wordBreak: "break-word",
                display: "block",
                color: "primary",
                fontStyle: "normal",
              },
            },
            p: {
              mt: 0,
              width: "100%",
              textAlign: ["start", "start", "center", "center"],
              fontSize: "21px",
              color: "dark",
            },
          }}
          dangerouslySetInnerHTML={{ __html: block.title }}
        />

        <Box
          sx={{
            my: [4, 5, 3],
            a: {
              textAlign: ["start", "start", "center", "center"],
              fontFamily: "mono",
              backgroundColor: "primary",
              borderRadius: "40px",
              color: "white",
              textTransform: "uppercase",
              fontWeight: 500,
              fontSize: block.contact ? [2, 2, 2, "16px"] : [1, 2, 2, "20px"],
              p: 3,
              textDecoration: "none",
              px: 4,
              ":hover": {
                backgroundColor: "secondary",
              },
            },
          }}
        >
          {block.link && block.link.link && block.link.anchor && (
            <InboundLink to={getPagePath(block.link.link, locale)}>
              {block.link.anchor}
            </InboundLink>
          )}
        </Box>
      </Flex>
    </Container>
  )
}

export default BigTitle
